import { useEffect, useState } from "react";
import axios from "axios";
import { FlaskConical } from "lucide-react";
import { API } from "@/lib/auth";
import { Skel } from "@/components/market/Shared";

const Card = ({ kind, product }) => {
  const [d, setD] = useState(null);
  useEffect(() => { setD(null); axios.get(`${API}/strategies/${kind}/backtest`, { params: { product }, timeout: 120000 }).then((r) => setD(r.data)).catch(() => setD({ error: true })); }, [kind, product]);
  if (!d) return <Skel h="h-48" />;
  if (d.error) return <div className="glass p-4 text-sm text-slate-400">Backtest unavailable right now.</div>;
  const good = d.net_return_pct > 0;
  return (
    <div className="glass p-4 space-y-3" data-testid={`strategy-${kind}`}>
      <div className="flex items-start justify-between gap-2"><div className="font-head font-bold text-xl leading-tight">{d.name}</div>
        <span className={`text-[10px] font-extrabold uppercase px-2 py-1 rounded-md ${d.signal.signal === "BUY" ? "bg-emerald-500 text-[#03140D]" : "bg-white/5 text-slate-400"}`} data-testid={`strategy-${kind}-signal`}>{d.signal.signal === "BUY" ? "Setup live" : "Waiting"}</span></div>
      <div className="grid grid-cols-3 gap-2 text-center font-num">
        {[["Trades", d.trades], ["Win rate", d.win_rate == null ? "—" : `${d.win_rate}%`], ["After fees", `${d.net_return_pct > 0 ? "+" : ""}${d.net_return_pct}%`]].map(([k, v]) => (
          <div key={k} className="rounded-lg bg-white/[0.03] border border-[var(--line)] py-2"><div className="text-[10px] uppercase text-slate-500 font-sans font-bold">{k}</div>
            <div className={`text-base font-extrabold ${k === "After fees" ? (good ? "text-emerald-300" : "text-rose-300") : ""}`}>{v}</div></div>))}
      </div>
      <p className="text-xs text-slate-400" data-testid={`strategy-${kind}-verdict`}>{good ? `Profitable over the last ${d.days} days after fees, but that's a short window.` :
        `Lost money over the last ${d.days} days. ${d.gross_wins} of ${d.trades} trades won before fees, but ${d.fee_each_side_pct}% Coinbase fees each way ate the small 1:1 moves. Practise on paper first.`}</p>
      <p className="text-[11px] text-slate-500">{d.signal.why || d.signal.reason}</p>
    </div>
  );
};

export const StrategyLab = () => {
  const [product, setProduct] = useState("BTC-USD");
  return (
    <section className="space-y-3" data-testid="strategy-lab">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h2 className="font-head font-extrabold uppercase text-2xl flex items-center gap-2"><FlaskConical className="w-5 h-5 text-[var(--violet)]" />Strategy lab</h2>
        <div className="flex gap-1 text-[11px] font-bold">{["BTC-USD", "ETH-USD", "SOL-USD"].map((p) => (
          <button key={p} onClick={() => setProduct(p)} className={`px-3 py-1.5 rounded-full border ${product === p ? "border-[var(--cyan)] text-[var(--cyan)]" : "border-[var(--line)] text-slate-500"}`} data-testid={`lab-product-${p}`}>{p.split("-")[0]}</button>))}</div>
      </div>
      <p className="text-xs text-slate-400">The two strategies from your videos, tested honestly on real Coinbase candles. Each trades at most once a day in the US session and is flat by 4 PM ET.</p>
      <div className="grid md:grid-cols-2 gap-3"><Card kind="orb15" product={product} /><Card kind="sweep_fvg" product={product} /></div>
    </section>
  );
};
